const createPt180InitState = () => ({
  pageNo: null,
  pageSize: null,
  searchAgainList: [{}],
  searchAgainPointList: [{}],
  searchList: [],
  searchPointList: [],
  totalGivenPointList: [{}],
  optionList: [],
  errList: [],
  initialization: [],
  matomeItemCount: 0,
  orderEditFlg: 0,
  catalogCdFlg: '0',
  catalogCdRequiredFlg: '0',
  quotationFlg: 0,
  kokyakuKbn: '',
  upperPartButtonFlg: '',
  amazonPayFlg: '0',
  oldOrderCd: null,
  oldReceiptNo: null,
  oldKessaiCd: null,
  priceShow: 0,
  tnkDspKbn: '0',
  itemCdFlg: 0,
  auraOpt: 0,
  puldownFlg: 0,
  givenPointFlg: 0,
  entetsuFlg: 0,
  entetsuAutoLoginFlg: 0,
  reqModel: {},
});

const createPt180ReqModelState = () => ({
  pageNo: null,
  pageSize: null,
  info: null,
  catalogCd: '',
  itemCd: null,
  qty: 1,
});

const state = () => ({
  pt180Init: createPt180InitState(),
  pt180ReqModel: createPt180ReqModelState(),
});

const mutations = {
  RESET_PT180_STATE(currentState) {
    currentState.pt180Init = createPt180InitState();
    currentState.pt180ReqModel = createPt180ReqModelState();
  },
  SET_PT180_INIT(currentState, payload = {}) {
    currentState.pt180Init = payload || {};
  },
  MERGE_PT180_INIT(currentState, payload = {}) {
    currentState.pt180Init = Object.assign({}, currentState.pt180Init, payload);
  },
  SET_PT180_REQ_MODEL(currentState, payload = {}) {
    currentState.pt180ReqModel = payload || {};
  },
  MERGE_PT180_REQ_MODEL(currentState, payload = {}) {
    currentState.pt180ReqModel = Object.assign({}, currentState.pt180ReqModel, payload);
  },
};

const getters = {
  pt180Init: currentState => currentState.pt180Init,
  pt180ReqModel: currentState => currentState.pt180ReqModel,
};

export {
  createPt180InitState,
  createPt180ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
